import React from 'react'
import Tdata from '../data/Tdata'
import Populardest from './Populardest';
import Stories from './Stories';
function Destination() {
  return (
    <>
    <Populardest/>
    <div className='bg pb-5 px-3'>
        <div className='container-fluid'>
        <h1 className='text-start pt-5 pb-5 fw-normal'>Our Packages</h1>
        <div className='row'>
      {Tdata.map((a)=>(
        <div className='col-lg-3'>
        <div className='card'>
          <img className='w-100' src={a.image}/>
          <div className='card-body text-center know1'>
          <p className='text-secondary  ps-2'>{a.title}</p>
          <h5 className='fw-normal text-body py-2'>{a.description}</h5>
          <button type="button" class="btn mt-3 px-3 know ">Know More</button>
          
          </div>
        </div>
       </div>
      
      ))}
      </div>
      <nav aria-label="Page navigation example">
  <ul class="pagination mt-4">
    <li class="page-item"><a class="page-link" href="/"><i class="bi bi-chevron-left"></i></a></li>
    <li class="page-item"><a class="page-link" href="">1</a></li>
    <li class="page-item"><a class="page-link" href="">2</a></li>
    <li class="page-item"><a class="page-link" href="/shop"><i class="bi bi-chevron-right"></i></a></li>
  </ul>
</nav>
      </div>
    </div>
    <Stories/>
    </>
  )
}

export default Destination
